import { render, staticRenderFns } from "./wxpay_mini.vue?vue&type=template&id=900a17a8&scoped=true"
import script from "./wxpay_mini.vue?vue&type=script&lang=js"
export * from "./wxpay_mini.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900a17a8",
  null
  
)

export default component.exports